import { render, staticRenderFns } from "./HNews.vue?vue&type=template&id=165cd0d4"
import script from "./HNews.vue?vue&type=script&lang=js"
export * from "./HNews.vue?vue&type=script&lang=js"
import style0 from "./HNews.vue?vue&type=style&index=0&id=165cd0d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports